import { render, staticRenderFns } from "./FloatingContactButtons.vue?vue&type=template&id=8fe0d26c&scoped=true"
import script from "./FloatingContactButtons.vue?vue&type=script&lang=js"
export * from "./FloatingContactButtons.vue?vue&type=script&lang=js"
import style0 from "./FloatingContactButtons.vue?vue&type=style&index=0&id=8fe0d26c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe0d26c",
  null
  
)

export default component.exports